import moment from 'moment';
import { flatMap } from 'lodash';
import { getEarliestBeginDate, getLatestEndDate, REPORT_STATUSES } from 'lib/components/Timeline/Timeline.helpers';
import { getId } from 'common/data.utils';

export const parseUnavailableData = (item, entityKey, earliest, latest, entityKeyToNameMap) => (unavailableItem) => {
    const { start, end } = unavailableItem;
    const startDate = moment(start).valueOf();
    const endDate = moment(end).valueOf();
    const state = REPORT_STATUSES.UNAVAILABLE;

    return {
        turbineData: { ...item, entityKey },
        key: entityKeyToNameMap[entityKey],
        type: state,
        beginDate: startDate < earliest ? earliest : startDate,
        endDate: endDate > latest ? latest : endDate,
        label: '',
    };
};
export const getUnavailableTurbineStatuses = (turbinesData, date, entityKeyToNameMap) =>
    flatMap(turbinesData, (item) => {
        const entityKey = getId(item);
        const earliest = getEarliestBeginDate(date);
        const latest = getLatestEndDate(date);

        const { un_availability } = item;
        const unavailableData = JSON.parse(un_availability);

        return unavailableData.map(parseUnavailableData(item, entityKey, earliest, latest, entityKeyToNameMap));
    });
